import { ChainedSchema } from '../../general/ChainedSchema';
import { primitive } from '../../inner/primitive';
const obsoleteConditionKeys = [];
class SerializrType_removeObsoleteConditonKeys extends ChainedSchema {
    deserializer(context) {
        const conditionKey = this.parentSchema.deserializer(context);
        if (obsoleteConditionKeys.includes(conditionKey)) {
            return 'never';
        }
        return this.parentSchema.deserializer(context);
    }
}
export const removeObsoleteConditionKeys = new SerializrType_removeObsoleteConditonKeys(primitive);
